<div class="dialog-wrapper" dir="rtl">
  <!-- Header -->
  <div class="dialog-header">
    <h2 class="dialog-title">إضافة تنبية لمسؤول المبيعات</h2>
    <button class="close-btn" (click)="onClose()">&#x2715;</button>
  </div>

  <!-- Body -->
  <div class="dialog-body">
    <!-- تاريخ التنبية -->
    <div class="form-group">
      <label class="form-label">تاريخ التنبية</label>
      <div class="date-wrapper">
        <input
          type="date"
          class="form-date"
          [(ngModel)]="alertDate"
          name="alertDate"
        />
      </div>
    </div>

    <!-- تعليق -->
    <div class="form-group">
      <label class="form-label">تعليق</label>
      <textarea
        class="form-textarea"
        [(ngModel)]="comment"
        name="comment"
        rows="4"
        placeholder=""
      ></textarea>
    </div>
  </div>

  <!-- Footer Buttons -->
  <div class="dialog-footer">
    <button class="btn btn-cancel" (click)="onClose()">إلغاء</button>
    <button class="btn btn-submit" (click)="onSubmit()">تسجيل</button>
  </div>
</div>
